module.exports = __webpack_public_path__ + "static/img/M-2.71ddf0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-2.png
// module id = KvRt
// module chunks = 0